import { Toaster } from "@/components/ui/toaster";
import ErrorBoundary from "@/components/ErrorBoundary";
import { LazyTooltipProvider } from "@/components/LazyTooltipProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import RootLayout from "./components/RootLayout";

// Eager import for landing page
import Index from "./pages/Index";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <LazyTooltipProvider>
        <Toaster />
        
        <BrowserRouter>
          <RootLayout>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </RootLayout>
        </BrowserRouter>
      </LazyTooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
